<button [type]="type()" [class]="buttonClass" [disabled]="disabled()" (click)="clicked()" [attr.form]="form()" aria-label="{{title()}}" [title]="title()">
  <ng-content></ng-content>
</button>
